// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
   SuiviOperationBCV2 — feuille de style UNIQUE de la vue acheteur operation-bc.
   Tout est porte par la racine .opbc : aucune fuite globale, aucune dependance
   accidentelle aux CSS d'autres pages. Cela corrige le fait que l'ancienne page
   n'a jamais possede son layout (.suivi-commande, .tab-content) ni le header
   (.status-container, .countdown-container) : ils etaient empruntes par accident
   a SuiviDeCommandeBC.css / SuiviOperation.css.
   Les feuilles lourdes reutilisees (ConsultationBC, OffreBC, CompteARebourd)
   conservent leur propre CSS — la frontiere est au niveau du contenu des onglets.
   ============================================================================= */

/* --- Layout page ---------------------------------------------------------- */
.opbc {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.opbc__content {
  /* Inset 6rem comme les autres pages ; le banner (hors de ce wrapper) reste pleine largeur. */
  padding: 0 6rem 2rem 6rem;
}

.opbc__tab-content {
  padding: 2rem 0;
  min-height: 500px;
}

/* --- Etats chargement / erreur / vide ------------------------------------- */
.opbc__loading,
.opbc__empty,
.opbc__error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-size: 1.8rem;
  color: #374151;
  text-align: center;
}

.opbc__error p {
  color: #dc2626;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}

/* --- Header --------------------------------------------------------------- */
.opbc__header {
  position: relative;
  background-color: #000000;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 2rem 4rem;
  color: #fffdfc;
  margin-bottom: 2rem;
}

.opbc__title,
.opbc__subtitle-main,
.opbc__subtitle {
  color: #ffffff;
}

.opbc__title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}

.opbc__subtitle {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 1.6rem;
  font-weight: 500;
  margin-bottom: 2rem;
}

.opbc__back-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-bottom: 1rem;
}

.opbc__back-button svg {
  width: 32px;
  height: 32px;
}

/* --- Statut + chrono ------------------------------------------------------ */
.opbc__status-container {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.opbc__status-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: #ffffff;
  padding: 1rem 1.2rem;
  border-radius: 50px;
}

.opbc__status-text {
  font-size: 1.6rem;
  font-weight: 700;
  /* La couleur est appliquee en ligne par OperationHeader (source de verite). */
}

.opbc__countdown-container {
  display: inline-flex;
  align-items: center;
  background-color: #ffffff;
  border-radius: 10px;
}

/* --- Barre d'onglets ------------------------------------------------------ */
.opbc__tab-nav {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e5e7eb;
}

.opbc__tab-nav-left {
  display: flex;
  gap: 2rem;
}

.opbc__tab-button {
  position: relative;
  background: none;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.4rem;
  color: #6b7280;
  cursor: pointer;
}

.opbc__tab-button:hover {
  color: #2c3948;
}

.opbc__tab-button.active {
  color: #2c3948;
  font-weight: 500;
}

.opbc__tab-button.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #f97316;
}

.opbc__tab-button.inactive,
.opbc__tab-button.disabled {
  color: #a1a1aa;
  cursor: not-allowed;
  opacity: 0.6;
}

.opbc__tab-button.inactive::after,
.opbc__tab-button.disabled::after {
  display: none;
}

.opbc__tab-button.inactive::before,
.opbc__tab-button.disabled::before {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 5px;
  padding: 5px 10px;
  background-color: #333333;
  color: #ffffff;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 1.2rem;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
  pointer-events: none;
  z-index: 100;
}

.opbc__tab-button.inactive:hover::before,
.opbc__tab-button.disabled:hover::before {
  opacity: 1;
  visibility: visible;
}

/* --- Onglets non implementes ---------------------------------------------- */
.opbc__placeholder {
  padding: 2rem;
  font-size: 1.6rem;
  color: #6b7280;
}

/* Accordeons de section : corps colle aux bords, scope a la case v2 uniquement
   (ne touche pas le composant partage AnalyseAccordion utilise par MS). */
.opbc .analyse-accordion-body {
  padding: 0;
}

/* Pas de vide en bas : le dernier element du corps colle au bord de l'accordeon. */
.opbc .analyse-accordion-body > *:last-child,
.opbc .analyse-accordion-body .section-content > *:last-child {
  margin-bottom: 0;
}

/* Table financiere : on garde le layout auto d'origine (les largeurs .article-*
   en % restent respectees, colonnes alignees, hauteurs normales). On absorbe
   juste le leger debordement (paddings des cellules) en masquant la scrollbar
   horizontale residuelle, et on laisse un code trop long casser plutot que
   d'etre coupe. Scope a la case v2. */
.opbc .articles-table-wrapper {
  overflow-x: hidden;
}

.opbc .articles-table-wrapper th,
.opbc .articles-table-wrapper td {
  overflow-wrap: break-word;
}

/* Alignement coherent en-tete + contenu, force par colonne : les MEMES regles
   s'appliquent au thead et au tbody, donc l'en-tete ne peut pas se desynchroniser
   du contenu, et ca surclasse la regle globale qui forcait les en-tetes a gauche.
   Vaut pour la table read-only (6 colonnes) comme editable (7 colonnes, +Actions).
   col1 N°Ref + col2 Description = gauche ; col3 Unite + col4 Quantite + col7
   Actions = centre ; col5 Prix + col6 Total = droite. */
.opbc .articles-table-wrapper th:nth-child(1),
.opbc .articles-table-wrapper td:nth-child(1),
.opbc .articles-table-wrapper th:nth-child(2),
.opbc .articles-table-wrapper td:nth-child(2) {
  text-align: left;
}

.opbc .articles-table-wrapper th:nth-child(3),
.opbc .articles-table-wrapper td:nth-child(3),
.opbc .articles-table-wrapper th:nth-child(4),
.opbc .articles-table-wrapper td:nth-child(4),
.opbc .articles-table-wrapper th:nth-child(7),
.opbc .articles-table-wrapper td:nth-child(7) {
  text-align: center;
}

.opbc .articles-table-wrapper th:nth-child(5),
.opbc .articles-table-wrapper td:nth-child(5),
.opbc .articles-table-wrapper th:nth-child(6),
.opbc .articles-table-wrapper td:nth-child(6) {
  text-align: right;
  padding-right: 1rem;
}

/* Le bouton supprimer suit l'alignement centre de sa cellule (pas de flottant). */
.opbc .articles-table-wrapper td:nth-child(7) .delete-button {
  float: none;
  margin: 0 auto;
}

/* Spinner de suppression : remplace la croix, meme taille (1em) et meme couleur. */
.opbc .delete-spinner {
  display: inline-block;
  width: 1em;
  height: 1em;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: opbc-delete-spin 0.6s linear infinite;
  vertical-align: middle;
}

@keyframes opbc-delete-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Bouton "Ajouter ou modifier un article" : ne deborde plus a droite du wrapper
   (il porte une marge de 1rem de chaque cote -> largeur bornee a 100% - 2rem). */
.opbc .articles-table-wrapper .add-article-button {
  box-sizing: border-box;
  max-width: calc(100% - 2rem);
}

/* =============================================================================
   Skeleton de chargement (shimmer). CSS auto-contenu, prefixe .opbc-sk, geometrie
   calee sur le vrai rendu (banniere SuiviHeader + onglets + contenu) pour eviter le saut.
   ============================================================================= */
@keyframes opbc-sk-shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.opbc-skeleton {
  pointer-events: none;
}

.opbc-sk {
  display: block;
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: opbc-sk-shimmer 1.4s ease-in-out infinite;
  border-radius: 6px;
}

/* Banniere : meme geometrie que SuiviHeader (.suivi-commande-title : padding 2rem 4rem,
   marge basse 2rem, fond sombre) pour une hauteur identique au vrai header. */
.opbc-sk-banner {
  padding: 2rem 4rem;
  margin-bottom: 2rem;
  background: #1f2937;
}

/* Sur fond sombre, les blocs shimmer sont clairs. */
.opbc-sk-banner .opbc-sk {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.14) 25%, rgba(255, 255, 255, 0.28) 50%, rgba(255, 255, 255, 0.14) 75%);
  background-size: 200% 100%;
}

.opbc-sk-back { padding: 1rem 0; }
.opbc-sk-back .opbc-sk-circle { width: 4.5rem; height: 4.5rem; border-radius: 50%; }

.opbc-sk-h1 { height: 4.1rem; display: flex; align-items: center; }
.opbc-sk-h1 .opbc-sk { width: 45%; height: 2.4rem; }

.opbc-sk-h2 { height: 3.1rem; display: flex; align-items: center; }
.opbc-sk-h2 .opbc-sk { width: 32%; height: 1.8rem; }

.opbc-sk-subtitle { height: 1.9rem; margin-bottom: 2rem; display: flex; align-items: center; }
.opbc-sk-subtitle .opbc-sk { width: 38%; height: 1.4rem; }

.opbc-sk-statusline { height: 2rem; display: flex; align-items: center; }
.opbc-sk-statusline .opbc-sk { width: 15rem; height: 1.8rem; border-radius: 20px; }

/* Barre d'onglets : mime .opbc__tab-nav (border-bottom, marge basse 3rem). */
.opbc-sk-tabs {
  display: flex;
  gap: 2rem;
  border-bottom: 1px solid #e5e7eb;
  padding: 1rem 0;
  margin-bottom: 3rem;
}
.opbc-sk-tab { width: 80px; height: 1.6rem; }

/* Contenu : empilement de blocs (le padding horizontal/vertical vient de .opbc__tab-content). */
.opbc-sk-content {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.opbc-sk-block { width: 100%; height: 90px; }
.opbc-sk-block--lg { height: 220px; }
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviOperationBCIV2/SuiviOperationBCIV2.css"],"names":[],"mappings":"AAAA;;;;;;;;;kFASkF;;AAElF,+EAA+E;AAC/E;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,6FAA6F;EAC7F,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,+EAA+E;AAC/E;;;EAGE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8EAA8E;AAChF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC,oBAAoB;EACpB,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;0EAC0E;AAC1E;EACE,UAAU;AACZ;;AAEA,mFAAmF;AACnF;;EAEE,gBAAgB;AAClB;;AAEA;;;;sCAIsC;AACtC;EACE,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;wDAKwD;AACxD;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;;;EAIE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,mFAAmF;AACnF;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;iFACiF;AACjF;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;;kFAGkF;AAClF;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yEAAyE;EACzE,0BAA0B;EAC1B,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;8EAC8E;AAC9E;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,+HAA+H;EAC/H,0BAA0B;AAC5B;;AAEA,gBAAgB,eAAe,EAAE;AACjC,gCAAgC,aAAa,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAEnF,cAAc,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAClE,uBAAuB,UAAU,EAAE,cAAc,EAAE;;AAEnD,cAAc,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAClE,uBAAuB,UAAU,EAAE,cAAc,EAAE;;AAEnD,oBAAoB,cAAc,EAAE,mBAAmB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAC7F,6BAA6B,UAAU,EAAE,cAAc,EAAE;;AAEzD,sBAAsB,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACxE,+BAA+B,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAElF,6EAA6E;AAC7E;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;AACA,eAAe,WAAW,EAAE,cAAc,EAAE;;AAE5C,gGAAgG;AAChG;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA,iBAAiB,WAAW,EAAE,YAAY,EAAE;AAC5C,qBAAqB,aAAa,EAAE","sourcesContent":["/* =============================================================================\n   SuiviOperationBCV2 — feuille de style UNIQUE de la vue acheteur operation-bc.\n   Tout est porte par la racine .opbc : aucune fuite globale, aucune dependance\n   accidentelle aux CSS d'autres pages. Cela corrige le fait que l'ancienne page\n   n'a jamais possede son layout (.suivi-commande, .tab-content) ni le header\n   (.status-container, .countdown-container) : ils etaient empruntes par accident\n   a SuiviDeCommandeBC.css / SuiviOperation.css.\n   Les feuilles lourdes reutilisees (ConsultationBC, OffreBC, CompteARebourd)\n   conservent leur propre CSS — la frontiere est au niveau du contenu des onglets.\n   ============================================================================= */\n\n/* --- Layout page ---------------------------------------------------------- */\n.opbc {\n  min-height: 100vh;\n  background-color: #f8f9fa;\n}\n\n.opbc__content {\n  /* Inset 6rem comme les autres pages ; le banner (hors de ce wrapper) reste pleine largeur. */\n  padding: 0 6rem 2rem 6rem;\n}\n\n.opbc__tab-content {\n  padding: 2rem 0;\n  min-height: 500px;\n}\n\n/* --- Etats chargement / erreur / vide ------------------------------------- */\n.opbc__loading,\n.opbc__empty,\n.opbc__error {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  font-size: 1.8rem;\n  color: #374151;\n  text-align: center;\n}\n\n.opbc__error p {\n  color: #dc2626;\n  font-size: 1.6rem;\n  margin-bottom: 1rem;\n}\n\n/* --- Header --------------------------------------------------------------- */\n.opbc__header {\n  position: relative;\n  background-color: #000000;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  padding: 2rem 4rem;\n  color: #fffdfc;\n  margin-bottom: 2rem;\n}\n\n.opbc__title,\n.opbc__subtitle-main,\n.opbc__subtitle {\n  color: #ffffff;\n}\n\n.opbc__title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  display: block;\n}\n\n.opbc__subtitle {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  font-size: 1.6rem;\n  font-weight: 500;\n  margin-bottom: 2rem;\n}\n\n.opbc__back-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin-bottom: 1rem;\n}\n\n.opbc__back-button svg {\n  width: 32px;\n  height: 32px;\n}\n\n/* --- Statut + chrono ------------------------------------------------------ */\n.opbc__status-container {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.opbc__status-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  background-color: #ffffff;\n  padding: 1rem 1.2rem;\n  border-radius: 50px;\n}\n\n.opbc__status-text {\n  font-size: 1.6rem;\n  font-weight: 700;\n  /* La couleur est appliquee en ligne par OperationHeader (source de verite). */\n}\n\n.opbc__countdown-container {\n  display: inline-flex;\n  align-items: center;\n  background-color: #ffffff;\n  border-radius: 10px;\n}\n\n/* --- Barre d'onglets ------------------------------------------------------ */\n.opbc__tab-nav {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.opbc__tab-nav-left {\n  display: flex;\n  gap: 2rem;\n}\n\n.opbc__tab-button {\n  position: relative;\n  background: none;\n  border: none;\n  padding: 1rem 2rem;\n  font-size: 1.4rem;\n  color: #6b7280;\n  cursor: pointer;\n}\n\n.opbc__tab-button:hover {\n  color: #2c3948;\n}\n\n.opbc__tab-button.active {\n  color: #2c3948;\n  font-weight: 500;\n}\n\n.opbc__tab-button.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #f97316;\n}\n\n.opbc__tab-button.inactive,\n.opbc__tab-button.disabled {\n  color: #a1a1aa;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.opbc__tab-button.inactive::after,\n.opbc__tab-button.disabled::after {\n  display: none;\n}\n\n.opbc__tab-button.inactive::before,\n.opbc__tab-button.disabled::before {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 5px;\n  padding: 5px 10px;\n  background-color: #333333;\n  color: #ffffff;\n  border-radius: 4px;\n  white-space: nowrap;\n  font-size: 1.2rem;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s, visibility 0.3s;\n  pointer-events: none;\n  z-index: 100;\n}\n\n.opbc__tab-button.inactive:hover::before,\n.opbc__tab-button.disabled:hover::before {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* --- Onglets non implementes ---------------------------------------------- */\n.opbc__placeholder {\n  padding: 2rem;\n  font-size: 1.6rem;\n  color: #6b7280;\n}\n\n/* Accordeons de section : corps colle aux bords, scope a la case v2 uniquement\n   (ne touche pas le composant partage AnalyseAccordion utilise par MS). */\n.opbc .analyse-accordion-body {\n  padding: 0;\n}\n\n/* Pas de vide en bas : le dernier element du corps colle au bord de l'accordeon. */\n.opbc .analyse-accordion-body > *:last-child,\n.opbc .analyse-accordion-body .section-content > *:last-child {\n  margin-bottom: 0;\n}\n\n/* Table financiere : on garde le layout auto d'origine (les largeurs .article-*\n   en % restent respectees, colonnes alignees, hauteurs normales). On absorbe\n   juste le leger debordement (paddings des cellules) en masquant la scrollbar\n   horizontale residuelle, et on laisse un code trop long casser plutot que\n   d'etre coupe. Scope a la case v2. */\n.opbc .articles-table-wrapper {\n  overflow-x: hidden;\n}\n\n.opbc .articles-table-wrapper th,\n.opbc .articles-table-wrapper td {\n  overflow-wrap: break-word;\n}\n\n/* Alignement coherent en-tete + contenu, force par colonne : les MEMES regles\n   s'appliquent au thead et au tbody, donc l'en-tete ne peut pas se desynchroniser\n   du contenu, et ca surclasse la regle globale qui forcait les en-tetes a gauche.\n   Vaut pour la table read-only (6 colonnes) comme editable (7 colonnes, +Actions).\n   col1 N°Ref + col2 Description = gauche ; col3 Unite + col4 Quantite + col7\n   Actions = centre ; col5 Prix + col6 Total = droite. */\n.opbc .articles-table-wrapper th:nth-child(1),\n.opbc .articles-table-wrapper td:nth-child(1),\n.opbc .articles-table-wrapper th:nth-child(2),\n.opbc .articles-table-wrapper td:nth-child(2) {\n  text-align: left;\n}\n\n.opbc .articles-table-wrapper th:nth-child(3),\n.opbc .articles-table-wrapper td:nth-child(3),\n.opbc .articles-table-wrapper th:nth-child(4),\n.opbc .articles-table-wrapper td:nth-child(4),\n.opbc .articles-table-wrapper th:nth-child(7),\n.opbc .articles-table-wrapper td:nth-child(7) {\n  text-align: center;\n}\n\n.opbc .articles-table-wrapper th:nth-child(5),\n.opbc .articles-table-wrapper td:nth-child(5),\n.opbc .articles-table-wrapper th:nth-child(6),\n.opbc .articles-table-wrapper td:nth-child(6) {\n  text-align: right;\n  padding-right: 1rem;\n}\n\n/* Le bouton supprimer suit l'alignement centre de sa cellule (pas de flottant). */\n.opbc .articles-table-wrapper td:nth-child(7) .delete-button {\n  float: none;\n  margin: 0 auto;\n}\n\n/* Spinner de suppression : remplace la croix, meme taille (1em) et meme couleur. */\n.opbc .delete-spinner {\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  border: 2px solid currentColor;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: opbc-delete-spin 0.6s linear infinite;\n  vertical-align: middle;\n}\n\n@keyframes opbc-delete-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Bouton \"Ajouter ou modifier un article\" : ne deborde plus a droite du wrapper\n   (il porte une marge de 1rem de chaque cote -> largeur bornee a 100% - 2rem). */\n.opbc .articles-table-wrapper .add-article-button {\n  box-sizing: border-box;\n  max-width: calc(100% - 2rem);\n}\n\n/* =============================================================================\n   Skeleton de chargement (shimmer). CSS auto-contenu, prefixe .opbc-sk, geometrie\n   calee sur le vrai rendu (banniere SuiviHeader + onglets + contenu) pour eviter le saut.\n   ============================================================================= */\n@keyframes opbc-sk-shimmer {\n  0% { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n\n.opbc-skeleton {\n  pointer-events: none;\n}\n\n.opbc-sk {\n  display: block;\n  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);\n  background-size: 200% 100%;\n  animation: opbc-sk-shimmer 1.4s ease-in-out infinite;\n  border-radius: 6px;\n}\n\n/* Banniere : meme geometrie que SuiviHeader (.suivi-commande-title : padding 2rem 4rem,\n   marge basse 2rem, fond sombre) pour une hauteur identique au vrai header. */\n.opbc-sk-banner {\n  padding: 2rem 4rem;\n  margin-bottom: 2rem;\n  background: #1f2937;\n}\n\n/* Sur fond sombre, les blocs shimmer sont clairs. */\n.opbc-sk-banner .opbc-sk {\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.14) 25%, rgba(255, 255, 255, 0.28) 50%, rgba(255, 255, 255, 0.14) 75%);\n  background-size: 200% 100%;\n}\n\n.opbc-sk-back { padding: 1rem 0; }\n.opbc-sk-back .opbc-sk-circle { width: 4.5rem; height: 4.5rem; border-radius: 50%; }\n\n.opbc-sk-h1 { height: 4.1rem; display: flex; align-items: center; }\n.opbc-sk-h1 .opbc-sk { width: 45%; height: 2.4rem; }\n\n.opbc-sk-h2 { height: 3.1rem; display: flex; align-items: center; }\n.opbc-sk-h2 .opbc-sk { width: 32%; height: 1.8rem; }\n\n.opbc-sk-subtitle { height: 1.9rem; margin-bottom: 2rem; display: flex; align-items: center; }\n.opbc-sk-subtitle .opbc-sk { width: 38%; height: 1.4rem; }\n\n.opbc-sk-statusline { height: 2rem; display: flex; align-items: center; }\n.opbc-sk-statusline .opbc-sk { width: 15rem; height: 1.8rem; border-radius: 20px; }\n\n/* Barre d'onglets : mime .opbc__tab-nav (border-bottom, marge basse 3rem). */\n.opbc-sk-tabs {\n  display: flex;\n  gap: 2rem;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 1rem 0;\n  margin-bottom: 3rem;\n}\n.opbc-sk-tab { width: 80px; height: 1.6rem; }\n\n/* Contenu : empilement de blocs (le padding horizontal/vertical vient de .opbc__tab-content). */\n.opbc-sk-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n}\n.opbc-sk-block { width: 100%; height: 90px; }\n.opbc-sk-block--lg { height: 220px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
